import { requiredUuidString } from '../zod-helpers/index.js';
import { contactFieldsInputSchema } from './contact-fields-input.js';
export const updateCalEventContactInputSchema = contactFieldsInputSchema.extend({
    contactId: requiredUuidString('Contact is required.', 'Invalid contact ID.'),
});
//# sourceMappingURL=update-cal-event-contact-input.js.map